import { cn } from "./classNames-DcGnTh2N.js";
import { jsx } from "react/jsx-runtime";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Overlay, Title } from "@radix-ui/react-dialog";
//#region src/components/Modal/ModalOverlay.tsx
const ModalOverlay = ({ ref, className, disableTransition = false, ...props }) => /* @__PURE__ */ jsx(Overlay, {
	...props,
	ref,
	className: cn("tw:fixed", "tw:inset-0", "tw:z-overlay", "tw:bg-scrim", "tw:data-[state=open]:duration-500", "tw:data-[state=open]:fade-in-0", "tw:data-[state=closed]:duration-500", "tw:data-[state=closed]:fade-out-0", { "tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out": !disableTransition }, className),
	onClick: (event) => event.stopPropagation()
});
//#endregion
//#region src/components/Modal/ModalDescription.tsx
const ModalDescription = ({ className, ...props }) => /* @__PURE__ */ jsx(DialogPrimitive.Description, {
	className: cn("tw:wrap-anywhere", "tw:text-sm", "tw:font-sans", "tw:tracking-normal", "tw:font-normal", "tw:text-muted-foreground", className),
	...props
});
//#endregion
//#region src/components/Modal/ModalTitle.tsx
const ModalTitle = ({ children, className, ...props }) => /* @__PURE__ */ jsx(Title, {
	...props,
	className: cn("tw:flex-1", "tw:wrap-anywhere", "tw:text-base", "tw:font-semibold", className),
	children
});
//#endregion
export { ModalDescription, ModalOverlay, ModalTitle };

//# sourceMappingURL=ModalTitle-RGWwIMU6.js.map